<template>
	<div class="MyBookList">
		<!-- mobile 我的书单Text -->
		<div class="titleReturn">
			<div class="return" @click="BookListReturn"><i class="el-icon-arrow-left"></i></div>
			我的知识平台
		</div>
		<!-- menu -->
		<div class="menuWrap">
			<div class="menuTap">
				<p class="lightTap">我的书单<span>{{ bookTotal }}</span>
				</p>
				<p @click="MenuTabFn" class="nolightTap">我的订单<span>{{ orderTotal }}</span>
				</p>
				<router-link v-if="layout === 0" to="/myCart" target="_blank">
					<i></i>
					<span class="my-cart-text">我的购物车</span>
					<span class="cart-num">{{ cartNum }}</span>
				</router-link>
			</div>
			<div class="search">
				<img src="../../assets/img/BookSearch_icon.svg" alt="" @click="GetBookList" />
				<input placeholder="请输入书名" v-model="bookName" @keydown.enter="GetBookList" />
			</div>
		</div>
		<!-- 我的书单 -->
		<div>
			<div class="myListWrap" v-if="ishaveBook">
				<!-- pc -->
				<ul class="bookList" v-if="layout == 0">
					<li v-for="(item, index) in MyBookList" :key="index">
						<a v-if="item.isVirtual" href="javascript:;" style="cursor: default;">
							<div class="imgWrap"><img :src="item.imagePath" alt="" :onerror="defaultImg" /></div>
							<div class="intrWrap">
								<div class="intr">
									<h5>{{ item.title }}</h5>
									<p>{{ item.abstract }}</p>
								</div>
								<div class="chapter">
									<span class="chapterIcon"></span>
									<span class="chapterNum">{{ item.purchasedCount + '/' }}<span>{{ item.sectionCount
									}}</span></span>
									<router-link
										:to="{ path: '/bookRead', query: { InformationId: item.id, id: item.informationContentId } }"
										target="_blank" class="readed">阅读已购章节</router-link>
								</div>
							</div>
						</a>
						<router-link v-else :to="{ path: '/bookDetail', query: { InformationId: item.id } }"
							target="_blank">
							<div class="imgWrap"><img :src="item.imagePath" alt="" :onerror="defaultImg" /></div>
							<div class="intrWrap">
								<div class="intr">
									<h5>{{ item.title }}</h5>
									<p>{{ item.abstract }}</p>
								</div>
								<div class="chapter">
									<span class="chapterIcon"></span>
									<span class="chapterNum">{{ item.purchasedCount + '/' }}<span>{{ item.sectionCount
									}}</span></span>
									<router-link
										:to="{ path: '/bookRead', query: { InformationId: item.id, id: item.informationContentId } }"
										target="_blank" class="readed">阅读已购章节</router-link>
								</div>
								<div class="to-new" v-if="item.latestPurchaseInformationContentId">
									<router-link
										:to="{ path: '/bookRead', query: { InformationId: item.id, id: item.latestPurchaseInformationContentId } }"
										target="_blank" class="readed">最新购买章节</router-link>
								</div>
							</div>
						</router-link>
					</li>
				</ul>
				<!-- mobile -->
				<ul class="bookList" v-else v-infinite-scroll="loadList" :infinite-scroll-disabled="noMore">
					<li v-for="(item, index) in MyBookList" :key="index">
						<!-- isVirtual：是否属于虚拟的书（有的商品是只有单篇文章，不属于任何一本书） -->
						<a v-if="item.isVirtual" href="javascript:;" style="cursor: default;">
							<div class="imgWrap"><img :src="item.imagePath" alt="" :onerror="defaultImg" /></div>
							<div class="intrWrap">
								<h5>{{ item.title }}</h5>
								<p>{{ item.abstract }}</p>
								<div class="chapter">
									<span class="chapterIcon"></span>
									<span class="chapterNum">{{ item.purchasedCount + '/' }}<span>{{ item.sectionCount
									}}</span></span>
									<router-link
										:to="{ path: '/bookRead', query: { InformationId: item.id, id: item.informationContentId } }"
										class="readed">阅读已购章节</router-link>
								</div>
							</div>
						</a>
						<router-link v-else :to="{ path: '/bookDetail', query: { InformationId: item.id } }">
							<div class="imgWrap"><img :src="item.imagePath" alt="" :onerror="defaultImg" /></div>
							<div class="intrWrap">
								<h5>{{ item.title }}</h5>
								<p>{{ item.abstract }}</p>
								<div class="chapter">
									<span class="chapterIcon"></span>
									<span class="chapterNum">{{ item.purchasedCount + '/' }}<span>{{ item.sectionCount
									}}</span></span>
									<router-link
										:to="{ path: '/bookRead', query: { InformationId: item.id, id: item.informationContentId } }"
										class="readed">阅读已购章节</router-link>
								</div>
								<div class="to-new" v-if="item.latestPurchaseInformationContentId">
									<router-link
										:to="{ path: '/bookRead', query: { InformationId: item.id, id: item.latestPurchaseInformationContentId } }"
										class="readed">最新购买章节</router-link>
								</div>
							</div>
						</router-link>
					</li>
				</ul>
				<p class="load" v-show="loading">加载中...</p>
				<p class="load" v-show="noMore">没有更多了</p>
				<!-- 分页器 -->
				<div class="page">
					<Pagination :total='pageTotal' :page="page" :pageSize='pagesize' @currentPage="currentPage">
					</Pagination>
				</div>
			</div>
			<!-- 空白页 -->
			<div class="blankWrap" v-else>
				<div class="blankBox">
					<img src="../../assets/img/bookBlankPage.svg" alt="" />
					<span>您没有任何记录</span>
				</div>
				<a href="javascript:;" @click="goToIndexFn">去书库</a>
			</div>
		</div>
	</div>
</template>

<script>
import Pagination from '../../components/Pagination.vue'
export default {
	name: 'MyBookList',
	data() {
		return {
			MyBookList: [], // 我的书单
			ishaveBook: true, // 是否有书单
			bookName: '', // 书名
			page: 1, // 当前页
			pagesize: 9, // 多少条数据
			pageTotal: 0, // 总数
			bookTotal: 0, // 我的书单总数
			loading: false, // 移动端控制加载中的显示
			layout: 0, // 布局 0：pc端布局 1：移动端布局
			orderTotal: 0, // 我的订单总数
			isshowMore: false, // 是否显示加载更多
			InformationId: undefined, // 情报id
			cartNum: 0, // 购物车数量
			defaultImg: 'this.src="' + require('../../assets/img/default_pic.png') + '"'
		}
	},
	created() {
		// 判断是否是移动端
		let wid = window.innerWidth;
		if (wid >= 320 && wid <= 1024) {
			this.layout = 1;
		} else {
			this.layout = 0;
		}

		// 获取书单
		this.GetBookList();
	},
	methods: {
		// 去书库 pc端嵌套在隧道网的iframe中，需要使用parent才能在整个窗口加载，否则就只能显示在iframe里
		goToIndexFn() {
			window.parent.location.href = `${Const_Api_Root}/#/Index`;
		},
		// 获取购物车数量
		getCartNumFn() {
			this.$fetch('/api/ShoppingCarts/count').then(res => {
				this.cartNum = res.data.count;
			}).catch(err => {
				throw err;
			});
		},
		// 获取书单
		GetBookList() {
			let params = `?PageNumber=${this.page}&PageSize=${this.pagesize}&Title=${this.bookName}&OrderByDictionary[latestPurchaseTime]=desc&OrderByDictionary[DisplayIndex]=desc`;
			this.$fetch('/api/information/myBooks' + params)
				.then((res) => {
					if (res.data.accessAllowed === false) {
						let nowHref = `${Const_Api_Root}/#/myBookList`;
						let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
						location.href = href;
						return;
					}

					// 获取订单数量
					this.GetOrderNumFn();
					// 获取购物车数量
					this.getCartNumFn();

					let headers = JSON.parse(res.headers["x-pagination"]);
					// 获取书单数
					if (!this.bookName) {
						this.bookTotal = headers.totalCount;
					}
					// 搜索到的数量
					this.pageTotal = headers.totalCount;
					// 获取书单列表
					if (this.layout == 1) {
						this.MyBookList = this.MyBookList.concat(res.data);
					} else {
						this.MyBookList = res.data;
					}
					// 没有书单 显示空白页
					if (!this.pageTotal) {
						this.ishaveBook = false;
					}
				}).catch((err) => {
					throw err;
				});
		},
		// 获取订单数量
		GetOrderNumFn() {
			let params = '?PageNumber=1&PageSize=20';
			this.$fetch('/api/orderInfo/myOrderInfoList' + params)
				.then((res) => {
					let headers = JSON.parse(res.headers["x-pagination"]);
					this.orderTotal = headers.totalCount;
				}).catch((err) => {
					throw err;
				});
		},
		// 菜单切换
		MenuTabFn() {
			this.$router.push('/myOrderList');
		},
		// 分页器
		currentPage(index) {
			this.page = index;
			this.GetBookList();
		},
		// 返回
		BookListReturn() {
			this.$router.go(-1);
		},
		// 移动端加载列表
		loadList() {
			this.loading = true;
			setTimeout(() => {
				this.page++;
				this.GetBookList();
				this.loading = false;
			}, 1000);
		}
	},
	computed: {
		noMore() {
			if (window.innerWidth >= 320 && window.innerWidth <= 1024) {
				return this.MyBookList.length >= this.pageTotal;
			} else {
				return true;
			}

		},
		disabled() {
			return this.loading || this.noMore
		}
	},
	components: {
		Pagination
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {

	.page {
		display: none;
	}

	/* mobile 我的书单Text */
	.titleReturn {
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: .3rem;
		background-color: #0078d7;
		position: relative;
		color: #FFFFFF;
	}

	.titleReturn .return {
		position: absolute;
		left: .25rem;
		top: 50%;
		transform: translateY(-50%);
		font-size: .4rem;
	}

	/* menu */
	.menuWrap {
		line-height: .8rem;
		flex-wrap: wrap;
	}

	.menuWrap .menuTap {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		height: 40px;
		line-height: 40px;
		border-bottom: solid 1px #dfdfdf;
	}

	.menuWrap .menuTap p {
		display: inline-block;
		letter-spacing: 0;
		font-size: .28rem;
		color: #000000;
		height: 40px;
		line-height: 40px;
		width: 50%;
		text-align: center;
	}

	.menuWrap .lightTap {
		border-bottom: .04rem solid #2468F2;
	}

	/* 我的书单列表 */
	.bookList {
		padding: 0 .25rem;
	}

	.bookList li {
		width: 100%;
		margin-top: .3rem;
	}

	.myListWrap li>a {
		width: 100%;
		padding: .2rem;
		min-height: 2.78rem;
	}

	.myListWrap .imgWrap {
		margin-right: .2rem;
	}

	.myListWrap li>a img {
		width: 1.66rem;
		height: 2.38rem;
	}

	.chapter,
	.to-new {
		margin-top: .2rem;
	}

	/* 搜索 */
	.menuWrap .search {
		display: flex;
		align-items: center;
		background: #F5F5F5;
		border-radius: 20px;
		width: 100%;
		height: 40px;
		margin: .2rem .25rem 0;
		padding: 0 .2rem;
	}

	.menuWrap .search img {
		margin-right: 12px;
	}

	.menuWrap .search input {
		background: #F5F5F5;
		flex: 1;
	}

	/* 移动端load */
	.load {
		text-align: center;
		margin: .4rem;
	}

	/* 加载更多 */
	.loadMoreWrap {
		width: 100%;
		margin: .4rem 0;
	}
}

@media screen and (min-width: 1029px) {

	.titleReturn,
	.load {
		display: none;
	}

	.menuWrap,
	.MyBookList ul {
		width: 1200px;
		margin: 0 auto;
	}

	/* menu */
	.menuWrap {
		line-height: 64px;
		margin: 0px auto 12px;
		background-color: #FFFFFF;
	}

	.menuWrap .menuTap p {
		margin-left: 24px;
		font-size: 16px;
		letter-spacing: 0;
		text-align: left;
		line-height: 24px;
		cursor: pointer;
		display: inline-block;
	}

	.menuWrap .menuTap a {
		display: inline-block;
		margin-left: 24px;
		position: relative;
	}

	.menuWrap .menuTap a i {
		display: inline-block;
		width: 16px;
		height: 16px;
		background: url(../../assets/img/booklist_cart_icon.png) no-repeat;
		background-size: 100% 100%;
		margin-top: 2px;
	}

	.menuWrap .menuTap a .my-cart-text {
		font-size: 16px;
		color: #3A3A3A;
		margin: 0 8px 0 6px;
	}

	.menuWrap .menuTap a .cart-num {
		display: inline-block;
		width: 48px;
		height: 22px;
		line-height: 22px;
		text-align: center;
		background: #F3F3F3;
		border-radius: 21px;
		font-size: 12px;
		color: #3A3A3A;
	}

	.menuWrap .nolightTap {
		color: #C8C8C8;
	}

	.menuWrap .lightTap {
		color: #333333;
	}

	.menuWrap .menuTap p span {
		background: rgba(140, 140, 140, 0.10);
		border-radius: 12px;
		line-height: 20px;
		padding: 3px 13px;
		font-size: 12px;
		color: #000000;
		margin-left: 4px;
	}

	.menuWrap .search {
		display: flex;
		align-items: center;
		background: #F5F5F5;
		border-radius: 20px;
		width: 260px;
		height: 40px;
		margin-right: 20px;
	}

	.menuWrap .search img {
		margin: 0 12px 0 22px;
	}

	.menuWrap .search input {
		background: #F5F5F5;
	}

	/* 列表 */
	.myListWrap ul {
		display: flex;
		flex-wrap: wrap;
		min-height: 618px;
		padding: 0 10px;
	}

	.myListWrap ul li {
		margin-right: 20px;
		margin-bottom: 20px;
	}

	.myListWrap li:nth-child(3n) {
		margin-right: 0;
	}

	.myListWrap li>a {
		width: 380px;
		padding: 16px;
		min-height: 186px;
	}

	.myListWrap .imgWrap {
		margin-right: 16px;
	}

	.myListWrap li>a img {
		width: 104px;
		height: 149px;
	}

	.chapter {
		margin-top: 18px;
	}

	.to-new {
		margin-top: 10px;
	}

	/* 加载更多 */
	.loadMoreWrap {
		width: 1200px;
		margin: 0 auto 117px;
		padding: 16px 0 24px;
		background-color: #FFFFFF;
	}

	.myListWrap .page {
		padding-bottom: 10px;
	}
}

.MyBookList {
	width: 100%;
	background: #FBFBFB;
	overflow: hidden;
}

/* menu */
.menuWrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

/* 列表 */
.bookList li>a {
	background: #FFFFFF;
	box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.06);
	border-radius: 4px;
	display: flex;
}

.intrWrap {
	width: 100%;
}

.intrWrap .intr {
	min-height: 94px;
}

.intrWrap h5 {
	font-size: 14px;
	color: #333333;
	letter-spacing: 0;
	line-height: 22px;
	margin-bottom: 5px;
}

.intrWrap p {
	height: 45px;
	font-size: 14px;
	color: #666666;
	letter-spacing: 0;
	line-height: 22px;
	word-break: break-all;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.chapter {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.chapter span {
	display: inline-block;
}

.chapter .chapterIcon {
	width: 16px;
	height: 16px;
	background: url(../../assets/img/ListChapter_icon.svg) no-repeat;
}

.chapter .chapterNum {
	font-size: 14px;
	color: #424242;
	letter-spacing: 0.6px;
	line-height: 14px;
}

.chapter .readed,
.to-new .readed {
	font-size: 14px;
	color: #2468F2;
	letter-spacing: 0;
	line-height: 14px;
	padding-right: 24px;
	background: url(../../assets/img/right_icon.svg) no-repeat center right;
}

.to-new {
	text-align: right;
}

/* 空白页 */
.blankWrap {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.blankWrap>a {
	width: 162px;
	line-height: 40px;
	background: #2468F2;
	border-radius: 4px;
	font-size: 14px;
	color: #FFFFFF;
	letter-spacing: 0;
	margin-bottom: 93px;
	text-align: center;
}

.blankBox {
	margin: 58px 0 28px;
	position: relative;
}

.blankBox>span {
	position: absolute;
	bottom: 11px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 12px;
	color: #424242;
	letter-spacing: 0;
	line-height: 12px;
}

/* 我的订单 */
.MyOrder {
	width: 100%;
	background: #FBFBFB;
	overflow: hidden;
}

/* 加载更多 */
.loadMoreWrap {
	display: flex;
	justify-content: center;
}

.loadMore {
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 2px;
	width: 88px;
	line-height: 32px;
	text-align: center;
	opacity: 0.65;
	font-size: 14px;
	color: #000000;
	line-height: 22px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/MemberCenter/MyBookList.vue